var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGooglePlayLogoinline = function SvgGooglePlayLogoinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 177,
    viewBox: "0 0 158 177",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.959%",
    y1: "99.838%",
    x2: "49.959%",
    y2: "-.048%",
    id: "GooglePlayLogo_inline_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0.1,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "56.498%",
    y1: "62.322%",
    x2: "68.157%",
    y2: "82.87%",
    id: "GooglePlayLogo_inline_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#991700",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#991700",
    stopOpacity: 0.1,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.8 79.1 17.4 3.3C11.7.1 6.6.4 3.5 3.4 1.3 5.5.1 8.9.1 13.3v151.3c0 4.4 1.3 7.8 3.4 9.9 3.2 3.1 8.2 3.4 13.9.1l133.4-75.8c9.6-5.4 9.6-14.2 0-19.7Z",
    fill: "#F4481E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.8 79.1 17.4 3.3C11.7.1 6.6.4 3.5 3.4 1.3 5.5.1 8.9.1 13.3v151.3c0 4.4 1.3 7.8 3.4 9.9 3.2 3.1 8.2 3.4 13.9.1l133.4-75.8c9.6-5.4 9.6-14.2 0-19.7Z",
    fill: "url(#GooglePlayLogo_inline_svg__a)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.8 80.1 17.4 4.3C7.8-1.1 0 3.4 0 14.3v-1c0-11 7.8-15.5 17.4-10l133.4 75.8c5 2.8 7.4 6.6 7.1 10.4-.2-3.4-2.5-6.8-7.1-9.4Z",
    fill: "#FFF",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.6 106.4c1.6-5.5 2.4-11.4 2.4-17.4 0-35.3-28.7-64-64-64S12 53.7 12 89c0 29.6 20.1 54.5 47.4 61.8l78.2-44.4Z",
    fill: "#FFD119",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FF8C00",
    fillRule: "nonzero",
    cx: 76,
    cy: 89,
    r: 40
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 25c-35.3 0-64 28.7-64 64 0 29.6 20.1 54.5 47.4 61.8l78.2-44.4c1.6-5.5 2.4-11.4 2.4-17.4 0-35.3-28.7-64-64-64Z",
    fill: "url(#GooglePlayLogo_inline_svg__b)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55 61)"
  }, /*#__PURE__*/React.createElement("image", {
    opacity: 0.15,
    width: 47,
    height: 60,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 7v24.6c-1.4-.8-3-1.3-4.7-1.3-5.2 0-9.3 4.2-9.3 9.3 0 5.2 4.2 9.3 9.3 9.3 5.2 0 9.7-4.2 9.7-9.3V17h9V7H21Z",
    fill: "#FAFAFA",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76 26c35.2 0 63.8 28.4 64 63.6V89c0-35.3-28.7-64-64-64S12 53.7 12 89v.5C12.3 54.4 40.8 26 76 26Z",
    fill: "#FFF",
    fillRule: "nonzero",
    opacity: 0.3
  }))));
};
export default SvgGooglePlayLogoinline;